import Calendario from '@/shared-components/calendario/Calendario';

export default {
  path: 'calendario',
  name: 'calendario',
  component: Calendario,
};
